<template>
  <div>
    <!-- View Note Details Modal -->
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="view-note-modal"
      hide-footer
      :title="capitalizedText"
    >
      <div v-if="isLoading" class="text-center py-5">
         <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
      <div v-else>
        <b-row>
            <b-col cols="12" class="text-right mb-3">
                 <b-button
                    v-if="pdf_link != ''"
                    @click="PrintNote(JOB_NO, pdf_link)"
                    size="sm"
                    variant="warning"
                 >
                 <i class="fa fa-file-pdf-o mr-1"></i> View PDF
                 </b-button>
            </b-col>
        </b-row>
      <b-row class="view-note-container">
        <b-col cols="4" class="mt-2">
          <div class="view-field">
            <label>Type</label>
            <div class="value">{{ noteModal.agentType || '-' }}</div>
          </div>
        </b-col>
        <b-col cols="4" class="mt-2">
          <div class="view-field">
            <label>To</label>
            <div class="value">{{ noteModal.AgentColoader || '-' }}</div>
          </div>
        </b-col>
        <b-col cols="4" class="mt-2" v-if="noteModal.agentType == 'Consignee'">
          <div class="view-field">
            <label>Consignee Address</label>
            <div class="value">{{ noteModal.agentconsigneeAddress || '-' }}</div>
          </div>
        </b-col>
        <b-col cols="4" class="mt-2" v-if="noteModal.agentType == 'Agent'">
          <div class="view-field">
            <label>Agent Country</label>
            <div class="value">{{ noteModal.agent_country || '-' }}</div>
          </div>
        </b-col>
        <b-col cols="4" class="mt-2">
          <div class="view-field">
            <label>Vessel/Voy</label>
            <div class="value">{{ noteModal.vesselVoy || '-' }}</div>
          </div>
        </b-col>
        <b-col cols="4" class="mt-2">
          <div class="view-field">
            <label>HBL/AWB</label>
            <div class="value">{{ noteModal.house_bl_no || '-' }}</div>
          </div>
        </b-col>
        <b-col cols="4" class="mt-2">
          <div class="view-field">
            <label>MBL/MAWB</label>
            <div class="value">{{ noteModal.master_bl_no || '-' }}</div>
          </div>
        </b-col>
        <b-col cols="4" class="mt-2">
          <div class="view-field">
            <label>SHIPPER</label>
            <div class="value">{{ noteModal.clientName || '-' }}</div>
          </div>
        </b-col>
        <b-col cols="4" class="mt-2">
          <div class="view-field">
             <label>CONSIGNEE</label>
             <div class="value">{{ noteModal.consignee || '-' }}</div>
          </div>
        </b-col>

        <b-col cols="4" class="mt-2">
          <div class="view-field">
            <label>Destination</label>
            <div class="value">{{ noteModal.FPOD || '-' }}</div>
          </div>
        </b-col>
        <b-col cols="4" class="mt-2">
          <div class="view-field">
            <label>Container No.</label>
            <div class="value">{{ noteModal.containerNoArryNote || '-' }}</div>
          </div>
        </b-col>
        <b-col cols="4" class="mt-2">
          <div class="view-field">
             <label>Container Type</label>
             <div class="value">{{ noteModal.containersTypes || '-' }}</div>
          </div>
        </b-col>
        <b-col cols="4" class="mt-2">
          <div class="view-field">
            <label>SHIPPER INV.</label>
            <div class="value">{{ noteModal.ShipperInvDet || '-' }}</div>
          </div>
        </b-col>
        <b-col cols="4" class="mt-2">
          <div class="view-field">
            <label>Booking No</label>
            <div class="value">{{ noteModal.validBookingNo || '-' }}</div>
          </div>
        </b-col>
        <b-col cols="4" class="mt-2">
          <div class="view-field">
            <label>SOB</label>
            <div class="value">{{ noteModal.SOB ? moment(noteModal.SOB) : '-' }}</div>
          </div>
        </b-col>
        <b-col cols="4" class="mt-2">
          <div class="view-field">
            <label>ETA Dest</label>
            <div class="value">{{ noteModal.ETADest ? moment(noteModal.ETADest) : '-' }}</div>
          </div>
        </b-col>
        <b-col cols="12" class="mt-2">
          <div class="view-field">
            <label>Remarks</label>
            <div class="value" style="white-space: pre-wrap;">{{ noteModal.remarks || '-' }}</div>
          </div>
        </b-col>
        <b-col cols="12">
          <table class="table table-sm table-bordered mt-3 note-table">
            <thead class="bg-light">
              <tr v-if="noteParticulars.length > 0">
                <th scope="col" style="width: 50px" class="text-center">SN.</th>
                <th scope="col">Particulars</th>
                <th scope="col">Container</th>
                <th scope="col" style="width: 80px" class="text-center">Qty</th>
                <th scope="col" style="width: 100px" class="text-right">Amount</th>
                <th scope="col" style="width: 120px" class="text-right">Final Amt</th>
                <th scope="col" style="width: 100px" class="text-center">Currency</th>
              </tr>
            </thead>
            <tbody style="background: white">
              <tr v-for="(item, index) in noteParticulars" :key="index">
                <th scope="row" class="text-center align-middle">{{ index + 1 }}.</th>
                <td class="align-middle">
                  {{ item.parti }}
                </td>
                <td class="align-middle small">
                    {{ item.container_selected || '-' }}
                </td>
                <td class="text-center align-middle">
                    {{ item.qty }}
                </td>
                <td class="text-right align-middle">
                  {{ item.amt }}
                </td>
                <td class="text-right align-middle">
                    {{ item.final_amt }}
                </td>
                <td class="text-center align-middle">
                   {{ getCurrencyCode(item.currency) }}
                </td>
              </tr>
              <tr v-if="TotAMT != 0">
                <td colspan="5" class="text-right">
                  <b style="color: blue; font-weight: bold; font-size: 16px">Total</b>
                </td>
                <td class="text-right">
                  <b style="color: blue; font-weight: bold; font-size: 16px">{{
                    TotAMT
                  }}</b>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </b-col>

        <b-col cols="12" class="text-center mt-3">
          <b-button variant="outline-danger" @click="hideNoteModal"
            >Close</b-button
          >
        </b-col>
      </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat } from "../../helper/filters";
import CommonService from "../../services/CommonService.js";

export default {
  name: "ViewNoteDetailsModal",
  props: {
    // Props passed from parent to trigger fetch
    noteDetails: {
        type: Object,
        default: () => ({})
    }
  },
  data() {
    return {
      isLoading: false,
      m_title: "",
      pdf_link: "",
      JOB_NO: "",
      
      TotAMT: 0,
      noteParticulars: [],
      CurrencyList: [],
      
      noteModal: {
        agentType: "",
        agent_country: "",
        agentconsigneeAddress: "",
        AgentColoader: "",
        vesselVoy: "",
        house_bl_no: "",
        master_bl_no: "",
        clientName: "",
        consignee: "",
        FPOD: "",
        containerNoArryNote: "",
        containersTypes: "",
        ShipperInvDet: "",
        validBookingNo: "",
        SOB: "",
        ETADest: "",
        remarks: "",
      },
      docURL: URL_BASE_DOC,
    };
  },
  
  computed: {
    capitalizedText() {
        return this.m_title || "Note Details";
    },
  },

  mounted() {
      // Fetch currency list on mount
      this.$store.dispatch(
        "common/setAllCurrencyList",
        JSON.stringify({ Currency: "Currency_DropDown" })
      );
  },

  methods: {
    moment(date) {
      if(!date) return '';
      return DateFormat(date);
    },
    
    getCurrencyCode(id) {
        const currencyList = this.$store.getters['common/getAllCurrencyList'] || [];
        const currency = currencyList.find(c => c.currency_id == id);
        return currency ? currency.currencyCode : id;
    },

    openModal(item) {
        this.isLoading = true;
        this.$refs["view-note-modal"].show();
        
        // Set basic details
        this.m_title = (item.NoteType === 'Credit Note' ? 'CREDIT NOTE - ' : 'DEBIT NOTE - ') + item.NoteSeries;
        this.pdf_link = item.PdfLink;
        this.JOB_NO = item.JobNo;
        
        // Populate validation from passed item first (List Data)
        this.populateModalData(item);
        
        // Handle note particulars from List Data if available
        if (item.noteParticulars && Array.isArray(item.noteParticulars)) {
             this.noteParticulars = item.noteParticulars;
             this.TotalAMT();
        }

        // Fetch full details
        this.getNoteDetails(item);
    },
    
    hideNoteModal() {
      this.$refs["view-note-modal"].hide();
    },

    PrintNote(ffExportFclSeries, uploadCreditDebit) {
      if(!ffExportFclSeries || !uploadCreditDebit) return;
      window.open(
        `${this.docURL}/ASSIGNMENT_UPLOADS/` +
          ffExportFclSeries.replaceAll("/", "_") +
          "/" +
          uploadCreditDebit
      );
    },

    getNoteDetails(item) {
      let payload = {
        itemCode: "getNoteItem",
        note_id: item.note_id,
        note_no: item.NoteSeries,
        allModuleId: item.JobId,
        page: item.page, 
      };
      
      CommonService.getCheckBLDetails(payload)
        .then((response) => {
          const { data, status } = response;
          if (status == 200 && data && data.getNoteItem) {
            this.getNoteItem = data.getNoteItem;
            
            // Parse noteParticulars if it is a string
            if (typeof this.getNoteItem.noteParticulars === 'string') {
                 try {
                    this.noteParticulars = JSON.parse(this.getNoteItem.noteParticulars);
                 } catch(e) {
                    this.noteParticulars = [];
                 }
            } else if (Array.isArray(this.getNoteItem.noteParticulars)) {
                this.noteParticulars = this.getNoteItem.noteParticulars;
            }
            
            this.populateModalData(this.getNoteItem);
            this.TotalAMT();
          }
        })
        .catch((error) => {
            console.error("Error fetching note details:", error);
        })
        .finally(() => {
            this.isLoading = false;
        });
    },

    populateModalData(data) {
        // Mapped to handle both editCRDRNote keys and List API keys
        this.noteModal = {
            agentType: data.agentType || data.type || data.AgentType || '',
            agent_country: data.agent_country || '', // List API might not have this, detail will
            agentconsigneeAddress: data.agentAddress || data.AgentColoaderDet || '', 
            AgentColoader: data.AgentColoader || data.agentName || '',
            vesselVoy: data.vesselVoy || data.VesselVoy || '',
            house_bl_no: data.BLNumber || data.house_bl_no || data.HBLNO || data.HblNo || '',
            master_bl_no: data.masterorLinerBlNo || data.master_bl_no || data.MBLNO || data.MblNo || '',
            clientName: data.shipper || data.Shipper || '',
            consignee: data.consignee || data.Consignee || '',
            FPOD: data.FinalPlace || data.FPOD || data.Fpod || '',
            containerNoArryNote: data.containerNoArryNote || '', // List doesn't seem to have container numbers string
            containersTypes: data.containerTypesArr || data.ContainerTypesArr || '',
            ShipperInvDet: data.ShipperInvDet || '',
            validBookingNo: data.validBookingNo || data.ValidBookingNo || '',
            SOB: data.SOB || data.SobDate || '',
            ETADest: data.ETADest || data.EtaDestEst || data.EtaDestActual || '',
            remarks: data.remarks || data.NoteContent || '',
        };
    },

    TotalAMT() {
      let TotAmount = 0;
      this.noteParticulars.forEach((value) => {
        let amount = value.final_amt ? parseFloat(value.final_amt) : (value.amt ? parseFloat(value.amt) : 0);
        TotAmount += amount;
      });
      this.TotAMT = TotAmount.toFixed(2);
    }
  }
};
</script>

<style scoped>
.view-field {
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 4px;
    padding: 8px 12px;
    min-height: 58px;
}
.view-field label {
    display: block;
    font-size: 0.75rem;
    font-weight: 600;
    color: #6c757d;
    margin-bottom: 2px;
    text-transform: uppercase;
}
.view-field .value {
    color: #212529;
    font-weight: 500;
    font-size: 0.95rem;
}
.note-table th {
    background-color: #f1f3f5;
    font-size: 0.85rem;
    font-weight: 600;
    text-transform: uppercase;
    color: #495057;
}
</style>



// WEBPACK FOOTER //
// ViewNoteDetailsModal.vue?ddd85fda